import { render, staticRenderFns } from "./CGooglePlay.vue?vue&type=template&id=910bcee0"
import script from "./CGooglePlay.vue?vue&type=script&lang=ts"
export * from "./CGooglePlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports